import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import {
  IconWrapper,
  NotificationActions,
  NotificationContent,
  StyledNotification,
  TextWrapper,
  pulseNoticeColors,
} from './styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import IconCarbonMisuseOutline from '@/shared/icons/IconCarbonMisuseOutline'
import IconAlertCircle from '@/shared/icons/NewDesign/IconAlertCircle'
import IconCarbonVoiceActivate from '@/shared/icons/IconCarbonVoiceActivate'
import IconCarbonInformation from '@/shared/icons/IconCarbonInformation'
import IconCarbonRocket from '@/shared/icons/IconCarbonRocket'
import IconCustomAgentScript from '@/shared/icons/IconCustomAgentScript'
import HandIcon from './icon_hand.svg'
import IconUnlocked from '@/shared/icons/NewDesign/IconUnlocked'
import IconLocked from '../../../icons/NewDesign/IconLocked'
import IconWarning from '@/shared/icons/NewDesign/IconWarning'
import IconVoice from '@/shared/icons/NewDesign/IconVoice'
import IconCheck from '@/shared/icons/NewDesign/IconCheck'
import IconTrophy from '@/shared/icons/NewDesign/IconTrophy'

const SDNotification = ({
  children,
  icon = true,
  type = '',
  boldText = false,
  hidden = false,
  primaryText,
  border = false,
  iconType,
  iconSize = 24,
  centerText = false,
  overrides = {},
}) => {
  const [, theme] = useStyletron()
  const isPulse = usePulseScope()

  if (hidden) return null

  const showIcon = icon !== false && type !== ''
  const colors = {
    negative: theme.colors.negative,
    error: theme.colors.negative,
    positive: theme.colors.positive,
    additionalSale: theme.colors.warning,
    warning: '#D2A604',
    default: '#0184EB',
  }
  const iconProps = isPulse
    ? { size: 16, color: pulseNoticeColors(theme, type).text }
    : { size: iconSize, color: colors[type] ?? colors.default }

  const getIcon = () => {
    const final = iconType ?? type
    switch (final) {
      case 'negative':
        return <IconCarbonMisuseOutline {...iconProps} />
      case 'error':
        return <IconAlertCircle {...iconProps} />
      case 'warning':
        return <IconWarning {...iconProps} />
      case 'info':
        return <IconVoice {...iconProps} />
      case 'positive':
        return <img src={HandIcon} alt={primaryText} width={iconProps.size} height={iconProps.size} />
      case 'unlocked':
        return <IconUnlocked {...iconProps} />
      case 'locked':
        return <IconLocked {...iconProps} />
      case 'script':
        return <IconCarbonVoiceActivate {...iconProps} />
      case 'agentScript':
        return <IconCustomAgentScript {...iconProps} />
      case 'additionalSale':
        return <IconCarbonRocket {...iconProps} />
      case 'check':
        return <IconCheck {...iconProps} />
      case 'trophy':
        return <IconTrophy {...iconProps} />
      default:
        return <IconCarbonInformation {...iconProps} />
    }
  }

  const renderedIcon = showIcon ? getIcon() : null

  return (
    <StyledNotification $type={type} $boldText={boldText} $border={border} $pulse={isPulse} {...overrides}>
      <NotificationContent $centerText={centerText} $pulse={isPulse}>
        {renderedIcon && <IconWrapper $pulse={isPulse}>{renderedIcon}</IconWrapper>}
        <TextWrapper $centerText={centerText} $pulse={isPulse}>
          <div dangerouslySetInnerHTML={{ __html: primaryText }} />
        </TextWrapper>
      </NotificationContent>
      {children && <NotificationActions $pulse={isPulse}>{children}</NotificationActions>}
    </StyledNotification>
  )
}

SDNotification.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.func, PropTypes.object]),
  type: PropTypes.oneOf([
    '',
    'additionalSale',
    'default',
    'error',
    'negative',
    'positive',
    'script',
    'warning',
    'agentScript',
    'info',
    'unlocked',
    'locked',
  ]),
  boldText: PropTypes.bool,
  hidden: PropTypes.bool,
  primaryText: PropTypes.string,
  border: PropTypes.bool,
  iconType: PropTypes.string,
  iconSize: PropTypes.number,
  centerText: PropTypes.bool,
  overrides: PropTypes.object,
}

export default SDNotification
